<template>
  <div class="myhome-empty-event dea-border-grey-medium" :class="{ 'myhome-empty-event--vertical': !isHorizontal }">
    <div class="myhome-empty-event__content">
      <img class="myhome-empty-event__image" :src="emptyEventImage" />
      <div class="myhome-empty-event__description">
        <p class="dea-heading--medium-xl">
          Cerca un corso di formazione adatto a te<span v-if="principal" class="dea-heading--medium-xl">
            o da organizzare nella tua scuola</span
          >!
        </p>
        <Buttons
          type="a"
          target="_blank"
          :href="$root.config.formazione_url"
          class="dea-button dea-button--large dea-button--iconRight"
          icon="go-to"
        >
          Vai a Deascuola Formazione
        </Buttons>
      </div>
    </div>
  </div>
</template>

<script>
import Buttons from "@/components/elements/Buttons";
import emptyEventImage from "~/assets/AP_dettaglioprodotto_368_formazione.png";

export default {
  name: "EmptyEvent",
  components: { Buttons },
  props: {
    align: {
      type: String,
      default: "horizontal",
      validator: val => {
        return ["horizontal", "vertical"].indexOf(val) > -1;
      },
    },
    principal: {
      type: Boolean,
      default: false,
    },
    parent: {
      type: Boolean,
      default: false,
    },
    student: {
      type: Boolean,
      default: false,
    },
    linkColor: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      emptyEventImage,
    };
  },
  computed: {
    isHorizontal() {
      return this.align === "horizontal";
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";
@import "~/scss/_empty-section"; //sass-lint:disable-line clean-import-paths

$event-icon: 80px;
$empty-section-image-max-width: 368px;

.myhome-empty-event {
  @include empty-section;
  border: $border-bold;
  border-radius: $border-radius-large;

  &__content {
    p {
      @include media("<=s") {
        text-align: left;
      }
    }
  }

  &__icon {
    align-self: flex-start;
    width: $event-icon;
  }

  &__description {
    @include media(">s") {
      margin-left: $space-large;
    }
    align-items: flex-start;
    display: flex;
    flex-direction: column;
  }

  &__image {
    max-width: $empty-section-image-max-width;
    width: 100%;
  }
}
</style>
